import { combineReducers } from "redux";
import userquestion from "../features/admin/legalrisk/userquestion/Slice";
import legaladvisorappointment from "../features/admin/legalrisk/legaladvisorappointment/Slice";





const legalrisk = combineReducers({
   userquestion: userquestion,
  legaladvisorappointment: legaladvisorappointment,
  });
  
  export default legalrisk;